function SettingIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
      style={{ marginRight: '3px' }}
    >
      <path
        fill='#5A6675'
        d='M20.83 14.6c-.93-.54-1.5-1.53-1.5-2.6s.57-2.06 1.5-2.6c.16-.1.22-.3.12-.46l-1.67-2.88a.32.32 0 00-.28-.17c-.06 0-.12.02-.17.05-.46.26-.98.4-1.5.4-.53 0-1.05-.14-1.52-.41a2.99 2.99 0 01-1.5-2.59c0-.19-.15-.34-.33-.34h-3.96c-.18 0-.33.15-.33.34 0 1.07-.57 2.05-1.5 2.59-.47.27-.99.41-1.52.41-.52 0-1.04-.14-1.5-.4a.319.319 0 00-.45.12L3.04 8.94c-.03.05-.04.11-.04.16 0 .12.06.23.17.3.93.54 1.5 1.52 1.5 2.59 0 1.08-.57 2.07-1.49 2.61h-.01c-.16.1-.22.3-.12.46l1.67 2.88c.06.11.17.17.28.17.06 0 .12-.02.17-.05.94-.53 2.09-.53 3.02.01.92.54 1.49 1.52 1.49 2.59 0 .19.15.34.34.34h3.96c.18 0 .33-.15.33-.34 0-1.07.57-2.05 1.5-2.59.47-.27.99-.41 1.52-.41.52 0 1.04.14 1.5.4.16.1.36.04.45-.12l1.68-2.88c.03-.05.04-.11.04-.16 0-.12-.06-.23-.17-.3zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z'
      />
    </svg>
  );
}

export default SettingIcon;
